<app-embedded-toolbar (onConfigure)="scope.openConfiguration()" [configurationName]="scope.translations.NAV_CONFIG"></app-embedded-toolbar>
<header>
    <div class="cielo-nav-notice" *ngIf="scope.config.showBanner && scope.config.bannerText">
        <mat-icon inline="true">info</mat-icon>
        <span [innerHtml]="scope.config.bannerText"></span>
    </div>
    <div class="header-container">
        <div class="header-container__items">
            <div appImgEditContainer="nav" [path]="scope.uploadImageIcon?.logo" name="Logo" [class.disabled_div]="(scope.isPreviewMode$ | async)">
                <a class="header-container__logo-wrap" disabledDiv href="/">
                    <img class="header-container__logo" [src]="scope.component.assets.logo" [alt]="scope.portalName" [ngStyle]="{'max-width': (scope.config.logoSize || '76')+'px'}">
                </a>
            </div>
            <nav class="nav" disabledDiv>
                <ul class="nav__list">
                    <ng-container *ngIf="(scope.userChanged$ | async) else unauthenticated">
                        <ng-container *ngTemplateOutlet="authenticated"></ng-container>
                    </ng-container>
                </ul>
            </nav>
        </div>
    </div>
</header>

<ng-template #unauthenticated>
    <ng-container *ngIf="(scope.routes$ | async) as routes">
        <ng-container *ngFor="let route of routes.unauthenticatedRoutes">
            <li class="nav__item">
                <a class="nav__link" *ngIf="!route.externalLink"
                   [routerLink]="route.link"
                   [routerLinkActive]="['nav__link--active']"
                   [routerLinkActiveOptions]="route.routerLinkActiveOptions || {}"
                   [innerText]="scope.getText | transform:route.textMapKey"></a>
                <a class="nav__link" *ngIf="route.externalLink"
                   [href]="route.externalLink"
                   [innerText]="scope.getText | transform:route.textMapKey"></a>
            </li>
        </ng-container>
    </ng-container>
    <li class="nav__item" *ngIf="scope.config.agencyWebsite">
        <a class="nav__link-button" [href]="scope.config.agencyWebsite" target="_blank" rel="noopener">
            {{scope.getText | transform:'BACK_TO_MAIN_SITE'}} <mat-icon inline="true">open_in_new</mat-icon>
        </a>
    </li>
</ng-template>

<ng-template #authenticated>
    <ng-container *ngIf="(scope.routes$ | async) as routes">
        <ng-container *ngFor="let route of routes.authenticatedRoutes">
            <li class="nav__item">
                <a class="nav__link" *ngIf="!route.externalLink"
                   [class.disabled_div]="route.link === '/logout' && (scope.isPreviewMode$ | async)"
                   [routerLink]="route.link"
                   [routerLinkActive]="['nav__link--active']"
                   [routerLinkActiveOptions]="route.routerLinkActiveOptions || {}"
                   [innerText]="scope.getText | transform:route.textMapKey"></a>
                <a class="nav__link" *ngIf="route.externalLink"
                   [href]="route.externalLink"
                   [innerText]="scope.getText | transform:route.textMapKey"></a>
            </li>
        </ng-container>
    </ng-container>
    <li class="nav__item">
        <a class="nav__link-button" [href]="scope.config.agencyWebsite" target="_blank" rel="noopener">
            {{scope.getText | transform:'BACK_TO_MAIN_SITE'}} <mat-icon inline="true">open_in_new</mat-icon>
        </a>
    </li>
</ng-template>